import React, { useEffect, useState } from 'react';
import './OfferSection.css';
import {
  DisplayOffer,
  _getLobOffers,
  fetchAndProcessOffers,
  getHeroImageUrl,
  getSkyImageUrl
} from '../../../../utils/offerService';
import { getAppEnv } from '../../../../../config/env';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

export const OfferSection = () => {
  const [cabOfferData, setCabOfferData] = useState<DisplayOffer[]>([]);

  useEffect(() => {
    (async () => {
      setCabOfferData(await fetchAndProcessOffers());
    })();
  }, []);
  const showOffersSection = cabOfferData.length > 0;

  return showOffersSection ? (
    <div className="offers" id="offer_id">
      <div className="offerSection">
        <div className="offerTitleSection">
          <span className="makeFlex perfectCenter">
            <img
              height={20}
              width={20}
              className="offerHeadImage"
              src={`${PUBLIC_URL}/static/public/offer_header.webp`}
            />
            <span className={`offerTitle`}>OFFERS</span>
          </span>
        </div>
        <ul className="offerCards">
          {cabOfferData.map(
            (
              { newHeroUrl, heroUrl, promoTitle, url, skyBigFullImgUrl },
              idx
            ) => {
              const imageUrl =
                getHeroImageUrl(heroUrl || newHeroUrl) ||
                getSkyImageUrl(skyBigFullImgUrl);
              return (
                <li key={`cab_offers_${idx}`} className="offerCard">
                  <div
                    className="offerPlaceHolder"
                    onClick={() => {
                      window.location = Object(url);
                    }}
                  >
                    {idx < 3 ? (
                      <img
                        className="offerImage"
                        src={imageUrl}
                        alt={`offer_img_${idx}`}
                      />
                    ) : (
                      <img
                        className="offerImage lazyload"
                        data-src={imageUrl}
                        alt={`offer_img_${idx}`}
                      />
                    )}
                  </div>
                  <div
                    className={`titleSection lineHeight16 font12 latoBlack blackText textCenter`}
                  >
                    {promoTitle}
                  </div>
                </li>
              );
            }
          )}
        </ul>
      </div>
    </div>
  ) : (
    <div className="offers" id="offer_id"></div>
  );
};
